// extracted by mini-css-extract-plugin
export default {"root":"leave-type-label_root__aasfG","leave":"leave-type-label_leave__Tt+5i","wfh":"leave-type-label_wfh__Md0Dn","inOffice":"leave-type-label_inOffice__13PRq"};